import cn from 'classnames'
import React, { ReactElement } from 'react'

import Card from '@components/Blocks/Cards/Card'
import BlockSection from '@components/Blocks/common/BlockSection'
import TransFromHtml from '@components/TransFromHtml'
import { useTranslation } from '@lib/i18n'

import '@components/Blocks/Cards/index.scss'

const CardsBlock = (props: PageBlocks.CardsBlock['data']): ReactElement => {
  const { translationKey, cards, alignText = 'center', imageSize = 'fullWidth', columns, ...rest } = props
  const { t } = useTranslation()
  const { title, description } = t<any, PageBlocks.CardTranslation>(`customBlocks.${translationKey}`, {
    returnObjects: true,
    defaultValue: {},
  })

  return (
    <BlockSection {...rest}>
      <div className={cn('cards-block', 'column', alignText, `image-size-${imageSize}`)}>
        {title && <h2 className="cell mb-3">{title}</h2>}
        {description && (
          <div className="body-16 mb-5 cards-block__description">
            <TransFromHtml i18nKey={`customBlocks.${translationKey}.description`} />
          </div>
        )}
        <div className="cell">
          <div
            className={cn('cards-block__cells-wrapper', { center: !!columns })}
            style={{ '--cell-columns': columns } as React.CSSProperties}
          >
            {cards.map(props => (
              <div key={props.translations} className="cards-block__cell">
                <Card {...props} translations={`${translationKey}.cards.${props.translations}`} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </BlockSection>
  )
}

export default CardsBlock
